import * as fromDatatype from "../datatype-library";

export interface bl_applet_notification_login_subject_subscription_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.VarcharDatatypeInterface;
    device_id: fromDatatype.VarcharDatatypeInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    event_description: fromDatatype.VarcharDatatypeInterface;
    notification_type: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    notification_subscription_guid: fromDatatype.GuidDataFieldInterface;
    contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
    auth_header_name: fromDatatype.VarcharDatatypeInterface;
    auth_header_value: fromDatatype.VarcharDatatypeInterface;
}

export class bl_applet_notification_login_subject_subscription_RowClass implements bl_applet_notification_login_subject_subscription_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.VarcharDatatypeInterface;
    device_id: string;
    event_code: string;
    event_description: string;
    notification_type: string;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    notification_subscription_guid: fromDatatype.GuidDataFieldInterface;
    contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
    auth_header_name: fromDatatype.VarcharDatatypeInterface;
    auth_header_value: fromDatatype.VarcharDatatypeInterface;
}